import { SessionStorageKeys } from 'constants/sessionStorageKeys';
import SessionStorageUtils from 'utils/SessionStorageUtils';

export const getEntityLink = (entity) => {
  const currentLocation = SessionStorageUtils.getData(SessionStorageKeys.LOCATION);

  if (!currentLocation) {
    console.error('Failed to get location from SessionStorage');
    return null;
  }

  if (currentLocation.admin) {
    return `/${entity}`;
  }

  if (currentLocation.transliteration) {
    return `/${currentLocation.transliteration}/${entity}`;
  }

  console.error('Missing transliteration to generate link');
  return null;
};
